export enum PanelBlocks {
  Panel = 'panel',
  TabletPanel = 'tabletPanel',
  MobilePanel = 'mobilePanel',
}
